import Vue from 'vue'
import Router from 'vue-router'
import home from '@/container/homePage/home'
import quanyi from "@/container/quanyiPage/quanyi"
import surroundings from "@/container/surroundingsPage/surroundings"
import surroundingsDetail from "@/container/surroundingsPage/surroundingsDetail"
import aboutUs from "@/container/aboutUsPage/aboutUs"
import activity from "@/container/activityPage/activity"
import activityList from "@/container/activityPage/activityList"
import activityDetail from "@/container/activityPage/activityDetail"
import vipIn from "@/container/vipInPage/vipIn"
//aboutUs的二级路由
import us from "@/container/aboutUsPage/aboutUs/us"
import location from "@/container/aboutUsPage/aboutUs/location"
import vipInfo from "@/container/aboutUsPage/aboutUs/vipInfo"
import getJifen from "@/container/aboutUsPage/aboutUs/getJifen"
import exchangeJifen from "@/container/aboutUsPage/aboutUs/exchangeJifen"
import rules from "@/container/aboutUsPage/aboutUs/rules"
import newVip from "@/container/aboutUsPage/aboutUs/newVip"


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/home',//匹配到这个字符串时我们重定向到'/home'这里来，也就是重新指向一个路由
      name: 'home',
      component: home

    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/quanyi',
      name: 'quanyi',
      component: quanyi
    },
    {
      path: '/surroundings',
      name: 'surroundings',
      component: surroundings
    },
    {
      path: '/surroundingsDetail/:infoId',
      name: 'surroundingsDetail',
      component: surroundingsDetail,
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      redirect:{name:'us'},
      component: aboutUs,
      children:[
        {
          path:'us',
          name: 'us',
          component: us
        },
        {
          path:'location',
          name:'location',
          component:location
        },
        {
          path:'vipInfo',
          name:'vipInfo',
          component:vipInfo
        },
        {
          path:'getJifen',
          name:'getJifen',
          component:getJifen
        },
        {
          path:'exchangeJifen',
          name:'exchangeJifen',
          component:exchangeJifen
        },
        {
          path:'rules',
          name:'rules',
          component:rules
        },
        {
          path:'newVip',
          name:'newVip',
          component:newVip
        }
      ]
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity,
    },
    {
      path: '/activityList',
      name: 'activityList',
      component: activityList,
    },
    {
      path: '/activityDetail/:infoId',
      name: 'activityDetail',
      component: activityDetail,
    },
    {
      path: '/vipIn',
      name: 'vipIn',
      component: vipIn,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js